import { render, staticRenderFns } from "./open-confirm.vue?vue&type=template&id=0c5a1898&scoped=true&"
import script from "./open-confirm.vue?vue&type=script&lang=js&"
export * from "./open-confirm.vue?vue&type=script&lang=js&"
import style0 from "./open.scss?vue&type=style&index=0&id=0c5a1898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5a1898",
  null
  
)

export default component.exports